'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var parcelAddComponent = exports.parcelAddComponent = {
    template: require('./parcel-add.html'),
    controllerAs: 'vm',
    bindings: {},
    controller: ["common", "gettextCatalog", "$state", "parcelService", "Analytics", function parcelAddController(common, gettextCatalog, $state, parcelService, Analytics) {
        'ngInject';

        var vm = this;

        vm.currentStep = 0;

        vm.receiver;
        vm.delivery;

        vm.initForm = initForm;
        vm.validateReceiver = validateReceiver;
        vm.selectReceiver = selectReceiver;
        vm.editReceiver = editReceiver;
        vm.submitStep2 = submitStep2;
        vm.editStep2 = editStep2;
        vm.submitStep3 = submitStep3;
        vm.cancel = cancel;

        vm.$onInit = init;

        function init() {
            var pageTitle = gettextCatalog.getString('parcel.createParcel');
            common.setTitle(pageTitle);
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/account/parcels/add-parcel', pageTitle);
            initForm();
        }

        function initForm() {
            vm.currentStep = 1;
            vm.receiver = null;
            vm.delivery = null;
        }

        function selectReceiver($event) {
            vm.currentStep = 2;
            vm.receiver = $event;
        }

        function validateReceiver($event) {
            return parcelService.validateReceiver($event.licenseNumber);
        }

        function submitStep2($event) {
            vm.currentStep = 3;
            vm.delivery = $event;
        }

        function submitStep3() {
            vm.currentStep = 4;

            var parcelAdd = {
                receiverCustomerNumber: vm.receiver.customerNumber,
                receiverLicenseNumber: vm.receiver.licenseNumber,
                remark: vm.delivery.remark,
                lines: vm.delivery.orderlines.map(function (ol) {
                    return { packageTypeId: ol.packageType.id,
                        packageValue: ol.packageValue, hasInsurance: ol.hasInsurance
                    };
                })
            };

            parcelService.add(vm.receiver.contactTypeId, parcelAdd).then(function (response) {
                $state.go('add-parcel-confirmation', { id: response.id });
            }).catch(function () {
                $state.go('error', {}, {
                    location: false
                });
            });
        }

        function editReceiver() {
            vm.currentStep = 1;
        }

        function editStep2() {
            vm.currentStep = 2;
        }

        function cancel() {
            $state.go('parcels');
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/account/parcels/parcel-add.js
// module id = 884
// module chunks = 0